// extracted by mini-css-extract-plugin
export default {"passwordExpiration":"PasswordExpiration_passwordExpiration__KjO61"};